export default __webpack_public_path__ + "static/media/salesforce-thrive-logo.82fb269c.svg";